import React from "react";
import classes from "./Sidebar.module.css";
import logo from "../../../assets/Next_Generation_Logo.png";
import WindowIcon from "@mui/icons-material/Window";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import CategoryIcon from "@mui/icons-material/Category";
import EventNoteIcon from "@mui/icons-material/EventNote";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import PersonIcon from "@mui/icons-material/Person";
import GradeIcon from "@mui/icons-material/Grade";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { decodeJwt, getToken } from "../../../utils/HelperFunctions";

const PmMenuItems = [
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: <WindowIcon />,
  },

  {
    name: "Booking Management",
    path: "/bookingManagement",
    icon: <EventNoteIcon />,
  },
  {
    name: "Property Management",
    path: "/propertyManagement",
    icon: <HomeWorkIcon />,
  },
];

const Sidebar = ({ onClose, isMobile }) => {
  const permissions = useSelector((state) => state.user?.permissions);
  const navigate = useNavigate();

  const handleItemClick = () => {
    if (isMobile && onClose) {
      onClose();
    }
  };

  const menuItems = [
    permissions &&
      (permissions[0] === "All" || permissions.includes("Dashboard")) && {
        name: "Dashboard",
        path: "/dashboard",
        icon: <WindowIcon />,
      },
    permissions &&
      (permissions[0] === "All" || permissions.includes("Scheduler")) && {
        name: "Scheduler",
        path: "/scheduler",
        icon: <EventNoteIcon />,
      },
    permissions &&
      (permissions[0] === "All" || permissions.includes("Chat")) && {
        name: "Chat",
        path: "/chat",
        icon: <ChatBubbleIcon />,
      },
    permissions &&
      (permissions[0] === "All" || permissions.includes("Updates")) && {
        name: "Updates",
        path: "/updates",
        icon: <TextSnippetIcon />,
      },
    permissions &&
      (permissions[0] === "All" ||
        permissions.includes("Property Manager")) && {
        name: "Property Manager",
        path: "/propertyManager",
        icon: <PeopleAltIcon />,
      },
    permissions &&
      (permissions[0] === "All" ||
        permissions.includes("Category Management")) && {
        name: "Category Management",
        path: "/categoryManagement",
        icon: <CategoryIcon />,
      },
    permissions &&
      (permissions[0] === "All" ||
        permissions.includes("Staff Management")) && {
        name: "Staff Management",
        path: "/staff",
        icon: <SupervisorAccountIcon />,
      },
    permissions &&
      (permissions[0] === "All" || permissions.includes("Questionnaire")) && {
        name: "Questionnaire",
        path: "/questionnaire",
        icon: <QuestionMarkIcon />,
      },
    permissions &&
      (permissions[0] === "All" || permissions.includes("User and Access")) && {
        name: "Users and Access",
        path: "/users",
        icon: <PersonIcon />,
      },
    permissions &&
      (permissions[0] === "All" || permissions.includes("Ratings")) && {
        name: "Ratings",
        path: "/ratings",
        icon: <GradeIcon />,
      },
  ];
  const permittedMenu = menuItems.filter((item) => Boolean(item));

  const tk = decodeJwt(getToken());

  return (
    <div className={`flex-col overflow-auto hidden-scroll ${classes.sidebar}`}>
      <div className={`flex-row ${classes.company_logo}`}>
        <img
          src={logo}
          className="pointer"
          onClick={() => {
            navigate("/home/dashboard");
            handleItemClick();
          }}
          alt="Company Logo"
        />
      </div>
      <div>
        <ul className="flex-col">
          {(tk?.role === 1 ? PmMenuItems : permittedMenu).map((item) => (
            <NavLink
              key={item?.name}
              to={`/home${item.path}`}
              className={({ isActive }) => (isActive ? classes.active : "")}
              onClick={handleItemClick}
            >
              <div className={`${classes.menu_item}`}>
                <li className="flex-row">
                  {item.icon}
                  {item.name}
                </li>
              </div>
            </NavLink>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
